import ExhibitionistBox from './ExhibitionistBox';
import ExhibitionistConfigPopoverLazy from './ExhibitionistConfigPopover/ExhibitionistConfigPopoverLazy';
import defaultRemoveConfirmation from '../defaultRemoveConfirmation';
export const getExhibitionistStripWidgetConfig = ({ t, dispatch, isGroup = false })=>({
        viewComponent: ExhibitionistBox,
        configPopoverComponent: ExhibitionistConfigPopoverLazy,
        confirmRemove: ()=>defaultRemoveConfirmation({
                t,
                dispatch
            }),
        widgetCard: {
            minuatureImageSrc: 'https://st.deviantart.net/eclipse/widgets/miniatures/2022/il8-3-carousel-gallery.svg',
            title: t('widgets.exhibitionist.scroller.addButtonHeader'),
            description: t(isGroup ? 'widgets.exhibitionist.scroller.group.description' : 'widgets.exhibitionist.scroller.description')
        }
    });
export const getExhibitionistGridWidgetConfig = ({ t, dispatch, isGroup = false })=>({
        viewComponent: ExhibitionistBox,
        configPopoverComponent: ExhibitionistConfigPopoverLazy,
        confirmRemove: ()=>defaultRemoveConfirmation({
                t,
                dispatch
            }),
        widgetCard: {
            minuatureImageSrc: 'https://st.deviantart.net/eclipse/widgets/miniatures/2022/il8-6-grid-gallery.svg',
            title: t('widgets.exhibitionist.gridGallery.addButtonHeader'),
            description: t(isGroup ? 'widgets.exhibitionist.gridGallery.group.description' : 'widgets.exhibitionist.gridGallery.description')
        }
    });
export default {
    getExhibitionistGridWidgetConfig,
    getExhibitionistStripWidgetConfig
};

//# sourceMappingURL=widgetConfig.js.map